export const FETCH_ORGS = 'FETCH_ORGS' as const;
export const FETCH_ORGS_SUCCESS = 'FETCH_ORGS_SUCCESS' as const;
export const FETCH_ORGS_FAIL = 'FETCH_ORGS_FAIL' as const;
export const FETCH_ORGS_CANCEL = 'FETCH_ORGS_CANCEL' as const;

export const FETCH_ORGS_PAGE = 'FETCH_ORGS_PAGE' as const;

export const FETCH_ORG = 'FETCH_ORG' as const;
export const FETCH_ORG_SUCCESS = 'FETCH_ORG_SUCCESS' as const;
export const FETCH_ORG_FAIL = 'FETCH_ORG_FAIL' as const;
export const FETCH_ORG_CANCEL = 'FETCH_ORG_CANCEL' as const;

export const FETCH_ORG_LICENSES = 'FETCH_ORG_LICENSES' as const;
export const FETCH_ORG_LICENSES_SUCCESS = 'FETCH_ORG_LICENSES_SUCCESS' as const;
export const FETCH_ORG_LICENSES_FAIL = 'FETCH_ORG_LICENSES_FAIL' as const;
export const FETCH_ORG_LICENSES_CANCEL = 'FETCH_ORG_LICENSES_CANCEL' as const;

export const FETCH_ORG_FIELDS = 'FETCH_ORG_FIELDS' as const;
export const FETCH_ORG_FIELDS_SUCCESS = 'FETCH_ORG_FIELDS_SUCCESS' as const;
export const FETCH_ORG_FIELDS_FAIL = 'FETCH_ORG_FIELDS_FAIL' as const;
export const FETCH_ORG_FIELDS_CANCEL = 'FETCH_ORG_FIELDS_CANCEL' as const;

export const SET_ORG_COLLECTION_BY_ATTRIBUTE = 'SET_ORG_COLLECTION_BY_ATTRIBUTE' as const;
export const SET_ORG_COLLECTION_BY_ATTRIBUTE_SUCCESS = 'SET_ORG_COLLECTION_BY_ATTRIBUTE_SUCCESS' as const;
export const SET_ORG_COLLECTION_BY_ATTRIBUTE_FAIL = 'SET_ORG_COLLECTION_BY_ATTRIBUTE_FAIL' as const;
export const SET_ORG_COLLECTION_BY_ATTRIBUTE_CANCEL = 'SET_ORG_COLLECTION_BY_ATTRIBUTE_CANCEL' as const;

export const SAVE_ORG = 'SAVE_ORG' as const;
export const SAVE_ORG_SUCCESS = 'SAVE_ORG_SUCCESS' as const;
export const SAVE_ORG_FAIL = 'SAVE_ORG_FAIL' as const;
export const SAVE_ORG_CANCEL = 'SAVE_ORG_CANCEL' as const;

export const DELETE_ORG_START = 'DELETE_ORG_START' as const;
export const DELETE_ORG_PROGRESS = 'DELETE_ORG_PROCESS' as const;
export const DELETE_ORG_END = 'DELETE_ORG_END' as const;

export const EDIT_ORG_START = 'EDIT_ORG_START' as const;
export const EDIT_ORG_END = 'EDIT_ORG_END' as const;
export const EDIT_ORG = 'EDIT_ORG' as const;

export const FETCH_PERMISSIONS = 'FETCH_PERMISSIONS' as const;
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS' as const;
export const FETCH_PERMISSIONS_FAIL = 'FETCH_PERMISSIONS_FAIL' as const;
export const FETCH_PERMISSIONS_CANCEL = 'FETCH_PERMISSIONS_CANCEL' as const;

export const FETCH_ORG_SETTINGS = 'FETCH_ORG_SETTINGS' as const;
export const FETCH_ORG_SETTINGS_SUCCESS = 'FETCH_ORG_SETTINGS_SUCCESS' as const;
export const FETCH_ORG_SETTINGS_FAIL = 'FETCH_ORG_SETTINGS_FAIL' as const;
export const FETCH_ORG_SETTINGS_CANCEL = 'FETCH_ORG_SETTINGS_CANCEL' as const;

export const SAVE_ORG_SETTINGS = 'SAVE_ORG_SETTINGS' as const;
export const SAVE_ORG_SETTINGS_SUCCESS = 'SAVE_ORG_SETTINGS_SUCCESS' as const;
export const SAVE_ORG_SETTINGS_FAIL = 'SAVE_ORG_SETTINGS_FAIL' as const;
export const SAVE_ORG_SETTINGS_CANCEL = 'SAVE_ORG_SETTINGS_CANCEL' as const;

export const FETCH_ORG_AUDIENCES = 'FETCH_ORG_AUDIENCES' as const;
export const FETCH_ORG_AUDIENCES_SUCCESS = 'FETCH_ORG_AUDIENCES_SUCCESS' as const;
export const FETCH_ORG_AUDIENCES_FAIL = 'FETCH_ORG_AUDIENCES_FAIL' as const;
export const FETCH_ORG_AUDIENCES_CANCEL = 'FETCH_ORG_AUDIENCES_CANCEL' as const;

export const EXPORT_ORGS = 'EXPORT_ORG' as const;
export const EXPORT_ORGS_SUCCESS = 'EXPORT_ORG_SUCCESS' as const;
export const EXPORT_ORGS_FAIL = 'EXPORT_ORG_FAIL' as const;
export const EXPORT_ORGS_CANCEL = 'EXPORT_ORG_CANCEL' as const;
